import { useState } from 'react';
import { useIntl } from 'react-intl';
import { Redirect } from 'react-router';
import { Route, Switch } from 'react-router-dom';

import { RECHARGE_ROUTES_URL } from 'constants/recharge-requests';
import {
  approveRechargeRequest,
  fetchReceiptImage,
  fetchRechargeRequests
} from 'services/wallet';
import { openModal } from 'utils/modal';
import { FILE_TYPE } from 'constants/wallet';

import BRHeader from 'components/BRHeader/BRHeader';
import BRTabs from 'components/BRTabs/BRTabs';
import Container from 'components/Container/index';
import CreditsRecharge from './components/CreditsRecharge/CreditsRecharge';
import WalletRecharge from './components/WalletRecharge/WalletRecharge';
import { notify } from 'components/Notify/Notify';
import ViewReceiptModal from './components/ViewReceiptModal/ViewReceiptModal';
import RejectRequestModal from './components/RejectRequestModal/RejectRequestModal';

import './RechargeRequests.less';

const RechargeRequests = () => {
  const intl = useIntl();
  const [isLoading, setIsLoading] = useState(false);
  const [isviewReceiptDisabled, setIsviewReceiptDisabled] = useState(false);

  const handleViewReceipt = async (requestId) => {
    setIsviewReceiptDisabled(true);
    setIsLoading(true);
    try {
      const {
        data: { attachmentUrl, attachmentType }
      } = await fetchReceiptImage(requestId);

      switch (attachmentType) {
        case FILE_TYPE.PDF:
          window.open(attachmentUrl, '_blank');
          setIsviewReceiptDisabled(false);

          break;

        default:
          openModal(ViewReceiptModal, {
            receiptLink: attachmentUrl,
            setIsviewReceiptDisabled
          });
          break;
      }
    } catch (error) {
      notify(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleReceiptRejectRequest = async (requestId, onSuccess) => {
    try {
      setIsLoading(true);
      openModal(RejectRequestModal, {
        requestId,
        onSuccess
      });
    } catch (error) {
      notify(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleApproveRechargeRequest = async (requestId, onSuccess) => {
    try {
      setIsLoading(true);
      const res = await approveRechargeRequest(requestId);
      notify(res.message, 'success');
    } catch (error) {
      notify(error.message);
    } finally {
      setIsLoading(false);
      onSuccess();
    }
  };

  const handleGetRequests = async (payload) => {
    try {
      setIsLoading(true);
      const { data } = await fetchRechargeRequests(payload);
      return data;
    } catch (error) {
      notify(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const RechargeTabProps = {
    isLoading,
    setIsLoading,
    isviewReceiptDisabled,
    handleViewReceipt,
    handleReceiptRejectRequest,
    handleApproveRechargeRequest,
    handleGetRequests
  };

  const TABS = {
    wallet: {
      label: intl.formatMessage({ id: 'recharge_requests.wallet.title' }),
      withProps: true,
      component: WalletRecharge,
      componentProps: RechargeTabProps,
      path: RECHARGE_ROUTES_URL.WALLET
    },
    bosta_credits: {
      label: intl.formatMessage({
        id: 'recharge_requests.bosta_credits.title'
      }),
      withProps: true,

      component: CreditsRecharge,
      componentProps: RechargeTabProps,
      path: RECHARGE_ROUTES_URL.BOSTA_CREDITS
    }
  };

  return (
    <Switch>
      <Route
        path={[RECHARGE_ROUTES_URL.WALLET, RECHARGE_ROUTES_URL.BOSTA_CREDITS]}
        render={() => (
          <Container
            className="br-recharge-requests-container"
            header={
              <BRHeader
                title={
                  <span className="display-xs">
                    {intl.formatMessage({ id: 'recharge_requests.title' })}
                  </span>
                }
              />
            }
            content={<BRTabs tabs={TABS} />}
          />
        )}
      />

      <Redirect to={RECHARGE_ROUTES_URL.WALLET} />
    </Switch>
  );
};

export default RechargeRequests;
